import { useRef, useEffect } from "react";
import { useParams } from "react-router-dom";

function ExamStudent() {
  const { studentId } = useParams();
  const studentName = "Maryam";

  const socket = useRef(null);
  const peerRef = useRef(null);
  const iceQueue = useRef([]);

  useEffect(() => {
    // 🔴 CHANGE THIS TO YOUR SERVER IP
    socket.current = new WebSocket("ws://192.168.40.1:5000");

    // ✅ STUN server is REQUIRED
    peerRef.current = new RTCPeerConnection({
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
    });

    socket.current.onopen = () => {
      console.log("Student connected to signaling server");

      socket.current.send(
        JSON.stringify({
          role: "student",
          studentId,
          name: studentName,
        })
      );
    };

    socket.current.onmessage = async (event) => {
      const msg = JSON.parse(event.data);

      // ✅ Handle answer SAFELY
      if (msg.answer) {
        if (peerRef.current.signalingState === "have-local-offer") {
          console.log("✅ Applying answer");
          await peerRef.current.setRemoteDescription(
            new RTCSessionDescription(msg.answer)
          );
        } else {
          console.warn(
            "⚠️ Ignoring duplicate answer. State:",
            peerRef.current.signalingState
          );
        }
      }

      // ✅ Handle ICE from admin
      if (msg.candidate) {
        if (peerRef.current.remoteDescription) {
          try {
            await peerRef.current.addIceCandidate(
              new RTCIceCandidate(msg.candidate)
            );
          } catch (e) {
            console.error("ICE add error:", e);
          }
        } else {
          iceQueue.current.push(msg.candidate);
        }
      }
    };

    // ✅ Send ICE to admin
    peerRef.current.onicecandidate = (e) => {
      if (e.candidate) {
        socket.current.send(
          JSON.stringify({
            candidate: e.candidate,
            to: "admin",
            from: studentId,
          })
        );
      }
    };

    return () => {
      socket.current.close();
      peerRef.current.close();
    };
  }, [studentId]);

  const startExam = async () => {
    console.log("🎥 Starting camera...");

    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });

    // ❌ NO LOCAL VIDEO PREVIEW

    stream.getTracks().forEach((track) => {
      peerRef.current.addTrack(track, stream);
    });

    const offer = await peerRef.current.createOffer();
    await peerRef.current.setLocalDescription(offer);

    socket.current.send(
      JSON.stringify({
        offer,
        studentId,
        studentName,
      })
    );

    // ✅ Apply queued ICE if any
    iceQueue.current.forEach(async (c) => {
      try {
        await peerRef.current.addIceCandidate(new RTCIceCandidate(c));
      } catch {}
    });
    iceQueue.current = [];
  };

  return (
    <div>
      <h1>Student Exam</h1>
      <button onClick={startExam}>Start Exam</button>
    </div>
  );
}

export default ExamStudent;
